module.exports = __webpack_public_path__ + "static/media/apple.8e2146e2.png";